import axios from './index';

/**
 * Types
 */
import type {
    AttachmentDto,
    AttachmentWithUserDto,
    CreateAttachmentDto,
    PresignedDto,
    PresignedResDto,
    QueryAttachmentDto,
    UpdateAttachmentDto,
} from '@/dtos/attachment.dto';
import type { Response } from '@/dtos/common.dto';

type AttachmentOptions = {
    /** 所属应用列表 */
    apps: string[];
    /** 所属模块列表 */
    modules: string[];
    /** 类型列表 */
    types: string[];
};

/**
 * APIs
 */
// 生成预签名 URL
export function attachmentsPresigned(params: PresignedDto) {
    return axios<Response<PresignedResDto>>('/v1/attachments/presigned', {
        params,
        method: 'get',
    }).then((res) => res.data);
}

// 创建附件信息
export function cAttachment(data: CreateAttachmentDto) {
    return axios<Response<AttachmentDto>>('/v1/attachments', {
        data,
        method: 'post',
    }).then((res) => res.data);
}

// 获取附件列表
export function attachments(params?: QueryAttachmentDto) {
    return axios<Response<AttachmentWithUserDto[]>>('/v1/attachments', {
        method: 'get',
        params,
    }).then((res) => res.data);
}

// 获取附件信息
export function rAttachment(id: string) {
    return axios<Response<AttachmentWithUserDto>>(`/v1/attachments/${id}`, {
        method: 'get',
    }).then((res) => res.data);
}

// 更新附件信息
export function uAttachment({ id, ...data }: { id: string } & UpdateAttachmentDto) {
    return axios<Response>(`/v1/attachments/${id}`, {
        data,
        method: 'patch',
    }).then((res) => res.data);
}

// 删除附件信息
export function dAttachment(id: string) {
    return axios<Response>(`/v1/attachments/${id}`, {
        method: 'delete',
    }).then((res) => res.data);
}

// 获取搜索选项列表
export function attachmentOptions() {
    return axios<Response<AttachmentOptions>>('/v1/attachments/options', {
        method: 'get',
    }).then((res) => res.data);
}
